export const BASE_URL = process.env.REACT_APP_BASE_URL
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN
export const ENVIRONMENT_NAME = process.env.REACT_APP_ENVIRONMENT_NAME

export const EventMessages = {
  saveShipments: 'SAVE_SHIPMENTS',
}
